import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';
import UserRole from '../../models/enums/user-roles';

export const selectUser = (state: RootState) => state.general.user;
export const selectCurrentUserRole = (state: RootState, ignoreCustom: boolean = false) =>
  state.general.customUserRole != null && !ignoreCustom
    ? state.general.customUserRole
    : state.general.user.data.role === UserRole.MEMBER
      ? UserRole.MEMBER
      : state.organizations.organizations.current?.id == null ||
          state.organizations.organizations.current?.id === state.general.user.data.organization.id
        ? state.general.user.data.role
        : UserRole.OWNER;
export const selectAccessToken = (state: RootState) => state.general.accessToken;
export const selectPendingTwoFactor = (state: RootState) => state.general.twoFactor.pending;
export const selectTwoFactorRest = (state: RootState) => state.general.twoFactor.rest;

const selectCurrentOrganizationId = (state: RootState) =>
  state.organizations.organizations.current?.id;
const selectCurrentRobotOrganizationId = (state: RootState) =>
  state.robots.robots.currentRobot?.organizationId;
const selectCurrentUserOrganizationId = (state: RootState) =>
  state.organizations.users.current?.organization.id;

export const selectIsUserAdminOrHigher = createSelector(
  [
    selectCurrentUserRole,
    selectUser,
    selectCurrentOrganizationId,
    selectCurrentRobotOrganizationId,
    selectCurrentUserOrganizationId,
  ],
  (role, user, currentOrganizationId, currentRobotOrganizationId, currentUserOrganizationId) => {
    const selfOrgId = user.data.organization.id;
    if (currentRobotOrganizationId != null || currentUserOrganizationId != null) {
      role = user.data.role;
    }

    return (
      role === UserRole.ADMIN ||
      role === UserRole.OWNER ||
      (role === UserRole.MODERATOR &&
        ((currentRobotOrganizationId != null && selfOrgId !== currentRobotOrganizationId) ||
          (currentUserOrganizationId != null && selfOrgId !== currentUserOrganizationId) ||
          (selfOrgId !== currentOrganizationId &&
            currentOrganizationId != null &&
            currentRobotOrganizationId == null &&
            currentUserOrganizationId == null)))
    );
  },
);

export const selectAgreementsData = (state: RootState) => state.general.agreements;
export const selectSelectedAgreement = (state: RootState) =>
  state.general.agreements.data?.find((a) => a.id === state.general.agreements.selectedId);
export const selectCustomLocalizations = (state: RootState) => state.general.customLocalizations;
export const selectNotifications = (state: RootState) => state.general.notifications;

export const selectVersionsData = (state: RootState) => state.general.versions;
export const selectInviteData = (state: RootState) => state.general.userInviteData;
export const selectFrontendParams = (state: RootState) => state.general.frontendParams;

export const selectTorizonPackages = (state: RootState) => state.general.versions.torizonPackages;
export const selectTorizonVersionSets = (state: RootState) => state.general.versions.torizonSets;
export const selectAssignableRobots = (state: RootState) => state.general.versions.assignableRobots;
